import styled from 'styled-components';
import { InputStyle } from '@pb/styles';

export const StyledTextArea = styled.textarea`
    ${InputStyle}
    width: 29rem;
    height: 14rem;
`;
